/** @format */
import React, { useState, useEffect } from 'react'
import { _$, Table } from 'kpc-react'
import styled from 'styled-components'
// import { request } from 'src/utils'
// import API from 'src/api/ApiCommon'
import { InstanceItem } from './constants'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'
import { LabelValueItem } from 'src/utils/interface'

interface ProjectInstanceProp {
  className?: string
  getSelectedInstaces: () => Promise<InstanceItem[]>
}
const ProjectInstanceDialog: React.FC<ProjectInstanceProp> = ({
  className,
  getSelectedInstaces
}) => {
  const gloabalRegionList = useGlobalData('monitorRegionList') as RegionStateType['list']
  const [selectedInstances, setSelectedInstances] = useState<InstanceItem[]>([])
  const [tableData, setTableData] = useState<InstanceItem[]>([])
  const [selectedGroup, setSelectedGroup] = useState<{ region: string }>({ region: '' })
  const [regionGrpup, setRegionGroup] = useState<LabelValueItem[]>([])
  useEffect(() => {
    if (gloabalRegionList?.length) {
      getSelectedInstaces().then(res => {
        const regionGroup = gloabalRegionList.map(item => {
          return {
            label: item.regionName,
            value: item.regionKey
          }
        })
        const filter = regionGroup.filter(
          ({ value }) => !!res.find(({ region }) => region === value)
        )
        setRegionGroup([{ label: _$('全部'), value: '' }, ...filter])
        setTableData(res || [])
        setSelectedInstances(res || [])
      })
    }
  }, [gloabalRegionList])

  // region筛选后修改表格
  useEffect(() => {
    if (selectedGroup.region) {
      const filter = selectedInstances.filter(({ region }) => selectedGroup.region === region)
      setTableData(filter)
    } else {
      setTableData(selectedInstances)
    }
  }, [selectedGroup])

  const selectedScheme = {
    instanceName: {
      title: _$('实例名称')
    },
    instanceIP: _$('IP地址'),
    region: {
      title: _$('region'),
      group: regionGrpup,
      template(item) {
        const find = regionGrpup.find(({ value }) => item.region === value)
        return find?.label || item.region
      }
    }
  }

  return (
    <div className={className}>
      <Table
        scheme={selectedScheme}
        data={tableData}
        checkType="none"
        resizable={true}
        rowKey={item => item.instanceId}
        group={selectedGroup}
        on$change-group={(_c, value) => {
          setSelectedGroup(value)
        }}
      />
    </div>
  )
}

export default styled(ProjectInstanceDialog)`
  .tabs-all {
    margin-top: 16px;
    .k-form {
      margin-top: 8px;
    }
    .table-page {
      margin-top: 0;
    }
  }
  .tabs-selected {
    margin-top: 16px;
    .k-table {
      margin-top: 16px;
    }
  }
`
